import { Component, OnDestroy, OnInit } from '@angular/core';
import { ShowcaseService } from 'src/app/services/header-showcase/showcase.service';

@Component({
    selector: 'app-ugc-fee-refund',
    templateUrl: './ugc-fee-refund.component.html',
    styleUrls: ['./ugc-fee-refund.component.scss']
})
export class UgcFeeRefundComponent implements OnInit, OnDestroy {
    src: string = '/assets/pdf/UGC-fee-refund-policy.pdf';
    title: string = 'UGC Fee Refund Policy';

    constructor(private showcaseService: ShowcaseService) {
        this.showcaseService.hideShowcase();
    }

    ngOnInit(): void {
    }

    ngOnDestroy(): void {
        this.showcaseService.showingShowcase();
    }

}
